import { getPrimaryColors } from 'theme/branding/custom-colors'

const whiteLabelPrimaryColor = '#242424'

export const whiteLabelTheme = {
  color: getPrimaryColors(whiteLabelPrimaryColor),
  shadow: {
    primaryHover: '0px 0px 3px 3px #0000001F',
    tertiaryHover: '0px 0px 3px 3px #00000008',
  },
}
